<template>
  <a-layout>
    <inspect-order ref="inspectOrder" :order-status-data="orderStatusData" :storer-data="storerData" @rowClick="rowClick" />
    <inspect-detail ref="inspectDetail" style="margin-top: 2px" @rowDblClick="rowDblClick" />
  </a-layout>
</template>

<script>
  import InspectOrder from '@/views/inbound/inspect/InspectOrder.vue'
  import InspectDetail from '@/views/inbound/inspect/InspectDetail.vue'

  export default {
    name: 'InspectQuery',
    components: { InspectDetail, InspectOrder },
    props: {
      orderStatusData: {
        type: Array,
        default: []
      },
      storerData: {
        type: Array,
        default: []
      }
    },
    methods: {
      rowClick(orderId) {
        this.$refs.inspectDetail.getData(orderId)
      },
      rowDblClick(detail) {
        this.$emit('rowDblClick', detail)
      },
      reset() {
        this.$refs.inspectDetail.reset()
        this.$refs.inspectOrder.reset()
      },
      supervise() {

      },
      baseDataEdit() {

      },
      save() {

      },
      pickUp() {

      },
      rejectPrint() {

      }
    }
  }
</script>